import type { Company } from '@kanda-libs/ks-frontend-services';

interface FormattedCompany {
  company: Company;
}

export const formatCompany = (company: Company): FormattedCompany => ({
  company,
});
